// extracted by mini-css-extract-plugin
export default {"root":"Cards-root-3Kb","rootCentered":"Cards-rootCentered-NIB","item":"Cards-item-1B4"};